module.exports = __webpack_public_path__ + "img/12-8.b27671a8.png";